package net.bothosting.docs.components.ui

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.*

/** A circular image with a subtle border — used for brand icons, server logos, etc. */
@Composable
fun RoundedIcon(
    src: String,
    size: CSSLengthNumericValue = 2.25.cssRem,   // h-9 / w-9 (36px)
    modifier: Modifier = Modifier,
) {
    Image(
        src = src,
        modifier = modifier
            .width(size)
            .height(size)
            .borderRadius(50.percent)
            .objectFit(ObjectFit.Cover)
            .border(1.px, LineStyle.Solid, Color.argb(0x80374151)),  // border-gray-700/50
    )
}

val Pulse = Keyframes {
    50.percent {
        Modifier.opacity(0.5)
    }
}

/** A small colored dot indicator — position it absolutely via [modifier]. */
@Composable
fun StatusDot(
    color: Color = Color.rgb(0x3B82F6),           // blue-500
    borderColor: Color = Color.rgb(0x111827),      // gray-900
    modifier: Modifier = Modifier,
) {
    Box(
        modifier
            .width(0.625.cssRem)                  // w-2.5 (10px)
            .height(0.625.cssRem)                  // h-2.5
            .borderRadius(50.percent)
            .backgroundColor(color)
            .border(2.px, LineStyle.Solid, borderColor)
            .animation(
                Pulse.toAnimation(
                    duration = 2.s,
                    timingFunction = AnimationTimingFunction.cubicBezier(0.4, 0.0, 0.6, 1.0),
                    iterationCount = AnimationIterationCount.Infinite
                )
            ),
    )
}

/** [RoundedIcon] with a [StatusDot] pinned to its top-right corner. */
@Composable
fun IconWithStatus(
    src: String,
    size: CSSLengthNumericValue = 2.25.cssRem,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier
            .position(Position.Relative)
            .flexShrink(0),
    ) {
        RoundedIcon(src = src, size = size)
        StatusDot(
            modifier = Modifier
                .position(Position.Absolute)
                .top((-2).px)                     // -top-0.5
                .right((-2).px),                  // -right-0.5
        )
    }
}
